// extracted by mini-css-extract-plugin
export default {"boxContainer":"styles_boxContainer__u-ens","text":"styles_text__0g2j1"};